import { render, staticRenderFns } from "./edit-payrollRequisition.vue?vue&type=template&id=5ac5a046"
import script from "./edit-payrollRequisition.vue?vue&type=script&lang=ts"
export * from "./edit-payrollRequisition.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports